module.exports = "/static/assets/c0933a65c76caab1d5d52bd21c1495e9.png";